import React, { useEffect, useState } from 'react'
import { FaDownload } from 'react-icons/fa'
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { quizResultRes, quizResultTodo } from '../../LMS_Redux/LMS_Slices/Course/QuizResult';
import { PropagateLoader } from 'react-spinners';
import ResultMeter from './ResultMeter';
import { IoIosCheckmarkCircle } from "react-icons/io";
import { getCertificateRes, getCertificateTodo } from '../../LMS_Redux/LMS_Slices/Course/GetCertificate';
import { toast } from 'react-toastify';
import { Spinner } from 'react-bootstrap';

export default function SubmitQuiz() {

    const { state } = useLocation()

    const dispatch = useDispatch()
    const result = useSelector(state => state.quizResult && state.quizResult.data && state.quizResult.data.data)
    const [loading, setLoading] = useState(false)
    const [spinner, setSpinner] = useState(false)
    const [bool, setBool] = useState(false)
    // console.log(result, 'reul')

    const quiz_result_res = () => {
        if (quizResultRes && quizResultRes.success) {
            setLoading(false)
        } else {
            setLoading(false)
        }
    }

    const mergedArray = result && result.questionList && result.questionList.map((item) => {
        const ans_by_user = result && result.lms_learner_questions && result.lms_learner_questions.find((obj) => obj.question_id === item.question_id)
        return { ...item, ans_by_user }
    })

    // console.log("mergedArray", mergedArray)

    // -----------------PDF GERNRATE-------------------

    const genratePdf = () => {
        // console.log(result)
        setSpinner(true)
        dispatch(getCertificateTodo(result)).then(() => certificate_res())
    }

    const certificate_res = () => {
        if (getCertificateRes && getCertificateRes.success) {
            setSpinner(false)
            setBool(!bool)
            window.open(process.env.REACT_APP_IMAGE_URL + getCertificateRes?.data, 'target_blank')
            toast.success(getCertificateRes.message, { position: "bottom-right" })
        } else {
            setSpinner(false)
            toast.error(getCertificateRes.message, { position: "bottom-right" })
        }
    }

    useEffect(() => {
        setLoading(true)
        dispatch(quizResultTodo(state)).then(() => quiz_result_res())
    }, [bool])

    return (
        <>
            {loading ?
                <div className='container-fluid'>
                    <div className='wrapper-admin'>
                        <div className='text-center mb-3'>
                            <PropagateLoader
                                color="#2262C6"
                                size={20}
                            />
                        </div>
                    </div>
                </div>
                :
                <div className='container-fluid'>
                    <h5 className='text-center mb-4'>You have <span className={result && result.result_status == 'pass' ? 'text-success text-capitalize' : 'text-danger text-capitalize'}>{result && result.result_status}</span> the Examination</h5>
                    <div className='row row-flex'>

                        <div className='col-3'>
                            <div className='box match_height'>
                                <div className="quiz-title">
                                    <h5>Total Questions : </h5><p> {result && result.total_questions}</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-3">
                            <div className='box match_height'>
                                <div className="quiz-title">
                                    <h5>Correct Answers : </h5>
                                    <p> {result && result.right_ans_count}</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-3">
                            <div className='box match_height'>
                                <div className="quiz-title">
                                    <h5>Wrong Answers : </h5>
                                    <p> {result && result.wrong_ans_count}</p>
                                </div>
                            </div>
                        </div>

                        {result && result.result_status == 'pass' ?
                            <div className='col-3'>
                                <div className='box match_height'>
                                    <h5>Get Certificate</h5>
                                    {result?.res_certificate == ''  || result?.res_certificate == null ?
                                        <button className="btn btn-primary" onClick={() => genratePdf()} target='_blank'>
                                            {spinner ?
                                                <Spinner
                                                    as="span"
                                                    animation="border"
                                                    size="sm"
                                                    role="status"
                                                    aria-hidden="true"
                                                    className=''
                                                />
                                                :
                                                <FaDownload color="white" fontSize="12px" />}
                                        </button>
                                        : <a href={result && process.env.REACT_APP_IMAGE_URL + result.res_certificate} className="btn btn-primary" target='_blank'><FaDownload color="white" fontSize="12px" /></a>
                                    }
                                </div>
                            </div>
                            : ''
                        }

                        <div className='col-md-6 m-auto'>

                            <ResultMeter series={result && result.percentage} />

                        </div>

                        <div className="col-md-12">
                            {mergedArray ?
                                mergedArray && mergedArray.map((value, index) => <div className='card mb-2' >
                                    <div className='card-header'>
                                        <span style={{ fontWeight: '500', fontSize: '16px' }}> Q:{index + 1}  {value && value.lms_question && value.lms_question.question}</span>
                                    </div>
                                    <div className='card-body' style={{ backgroundColor: 'aliceblue' }}>
                                        <div className="row">

                                            {(value && value.lms_question && value.lms_question.option1) || (value && value.lms_question && value.lms_question.image_option1) ?
                                                <div className="col-md-3">
                                                    A. <span className={value && value.ans_by_user && value.ans_by_user.submit_ans === 'A' ? 'user_by' : ''}> {value && value.lms_question && value.lms_question.option1}</span> {value && value.lms_question && value.lms_question.correct_ans === 'A' ? <IoIosCheckmarkCircle style={{ color: "green" }} size={20} className=' ms-1 mb-1' /> : ''}
                                                    {
                                                        value && value.lms_question && value.lms_question.image_option1 === null || value && value.lms_question && value.lms_question.image_option1 === '' ? '' :
                                                            <div style={{ height: '20vh' }}>
                                                                <img src={process.env.REACT_APP_IMAGE_URL + value.lms_question.image_option1} alt="img" className='img-fluid' style={{ maxHeight: '100%' }} />
                                                            </div>}
                                                </div> : ""}

                                            {(value && value.lms_question && value.lms_question.option2) || (value && value.lms_question && value.lms_question.image_option2) ?
                                                <div className="col-md-3">
                                                    B. <span className={value && value.ans_by_user && value.ans_by_user.submit_ans === 'B' ? 'user_by' : ''}>  {value && value.lms_question && value.lms_question.option2}</span>{value && value.lms_question && value.lms_question.correct_ans === 'B' ? <IoIosCheckmarkCircle style={{ color: "green" }} size={20} className=' ms-1 mb-1' /> : ''}
                                                    {value && value.lms_question && value.lms_question.image_option2 === null || value && value.lms_question && value.lms_question.image_option2 === '' ? '' :
                                                        <div style={{ height: '20vh' }}>
                                                            <img src={process.env.REACT_APP_IMAGE_URL + value.lms_question.image_option2} alt="img" className='img-fluid' style={{ maxHeight: '100%' }} />
                                                        </div>}
                                                </div> : ""}

                                            {(value && value.lms_question && value.lms_question.option3) || (value && value.lms_question && value.lms_question.image_option3) ?
                                                <div className="col-md-3">
                                                    C. <span className={value && value.ans_by_user && value.ans_by_user.submit_ans === 'C' ? 'user_by' : ''}> {value && value.lms_question && value.lms_question.option3}</span>{value && value.lms_question && value.lms_question.correct_ans === 'C' ? <IoIosCheckmarkCircle style={{ color: "green" }} size={20} className=' ms-1 mb-1' /> : ''}
                                                    {
                                                        value && value.lms_question && value.lms_question.image_option3 === null || value && value.lms_question && value.lms_question.image_option3 === '' ? '' :
                                                            <div style={{ height: '20vh' }}>
                                                                <img src={process.env.REACT_APP_IMAGE_URL + value.lms_question.image_option3} alt="img" className='img-fluid' style={{ maxHeight: '100%' }} />
                                                            </div>}
                                                </div> : ""}

                                            {(value && value.lms_question && value.lms_question.option4) || (value && value.lms_question && value.lms_question.image_option4) ?
                                                <div className="col-md-3">
                                                    D. <span className={value && value.ans_by_user && value.ans_by_user.submit_ans === 'D' ? 'user_by' : ''}> {value && value.lms_question && value.lms_question.option4}</span>{value && value.lms_question && value.lms_question.correct_ans === 'D' ? <IoIosCheckmarkCircle style={{ color: "green" }} size={20} className=' ms-1 mb-1' /> : ''}
                                                    {value && value.lms_question && value.lms_question.image_option4 === null || value && value.lms_question && value.lms_question.image_option4 === '' ? '' :
                                                        <div style={{ height: '20vh' }}>
                                                            <img src={process.env.REACT_APP_IMAGE_URL + value.lms_question.image_option4} alt="img" className='img-fluid' style={{ maxHeight: '100%' }} />
                                                        </div>}
                                                </div> : ""}

                                            {(value && value.lms_question && value.lms_question.option5) || (value && value.lms_question && value.lms_question.image_option5) ?
                                                <div className="col-md-3">
                                                    E. <span className={value && value.ans_by_user && value.ans_by_user.submit_ans === 'E' ? 'user_by' : ''}> {value && value.lms_question && value.lms_question.option5}</span>{value && value.lms_question && value.lms_question.correct_ans === 'E' ? <IoIosCheckmarkCircle style={{ color: "green" }} size={20} className=' ms-1 mb-1' /> : ''}
                                                    {value && value.lms_question && value.lms_question.image_option5 === null || value && value.lms_question && value.lms_question.image_option5 === '' ? '' :
                                                        <div style={{ height: '20vh' }}>
                                                            <img src={process.env.REACT_APP_IMAGE_URL + value.lms_question.image_option5} alt="img" className='img-fluid' style={{ maxHeight: '100%' }} />
                                                        </div>}
                                                </div> : ""}
                                        </div>
                                    </div>
                                </div>) : ''}
                        </div>

                    </div>
                </div>
            }
        </>
    )
}
